import type { Project } from '../api/types';

export const projectOrderKey = (userId: number) => `tab:project-order:${userId}`;

export function readProjectOrder(userId: number): number[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(projectOrderKey(userId)) ?? '[]');
    return Array.isArray(value) ? [...new Set(value.filter((id): id is number => typeof id === 'number' && Number.isInteger(id) && id > 0))] : [];
  } catch { return []; }
}

export function writeProjectOrder(userId: number, ids: number[]): boolean {
  try { localStorage.setItem(projectOrderKey(userId), JSON.stringify(ids)); return true; }
  catch { return false; }
}

export function orderedProjects(projects: Project[], ids: number[]): Project[] {
  const rank = new Map(ids.map((id, index) => [id, index]));
  return [...projects].sort((left, right) =>
    ((rank.get(left.id) ?? Infinity) - (rank.get(right.id) ?? Infinity)) || left.title.localeCompare(right.title, 'ru', { numeric: true }));
}

export function moveProject(ids: number[], movedId: number, targetId: number, after: boolean): number[] {
  if (movedId === targetId || !ids.includes(movedId) || !ids.includes(targetId)) return ids;
  const next = ids.filter(id => id !== movedId);
  next.splice(next.indexOf(targetId) + (after ? 1 : 0), 0, movedId);
  return next;
}
